export default __webpack_public_path__ + "static/media/family-gathering-tablet@2x.b6beb22d.jpg";